import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails"; // Import ProductDetails component
import Navbar from "./components/Navbar"; // Importing Navbar
import Footer from "./components/footer"; // Importing Footer

function App() {
  return (
    <div>
      {/* Add Navbar so it appears on all pages */}
      <Navbar />

      {/* Main Content: Define routes for the pages */}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetails />} /> {/* Add this route */}
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      {/* Add Footer here so it appears on all pages */}
      <Footer />
    </div>
  );
}

export default App;
